'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import SVG, { SVGProps } from '../svg'
import { colors } from '@theme'

// SVGs
// @ts-ignore
import ArrowLeftSVG from './arrow-left.react.svg'
// @ts-ignore
import ArrowRightSVG from './arrow-right.react.svg'
// @ts-ignore
import ArrowUpSVG from './arrow-up.react.svg'
// @ts-ignore
import AvatarPharmacistFilledSVG from './avatar-pharmacist-filled.react.svg'
// @ts-ignore
import BackSVG from './back.react.svg'
// @ts-ignore
import CalendarSVG from './calendar.react.svg'
// @ts-ignore
import CautionSVG from './caution.react.svg'
// @ts-ignore
import CheckMarkWhiteSVG from './checkmark-white.react.svg'
// @ts-ignore
import CheckMarkVioletSVG from './checkmark-violet.react.svg'
// @ts-ignore
import CheckCircleSVG from './check-circle.react.svg'
// @ts-ignore
import CheckMarkPulseSVG from './checkmark-pulse.react.svg'
// @ts-ignore
import CopySVG from './copy.react.svg'
// @ts-ignore
import ChevronLeftSVG from './chevron-left.react.svg'
// @ts-ignore
import ChevronRightSVG from './chevron-right.react.svg'
// @ts-ignore
import ChevronDownSVG from './chevron-down.react.svg'
// @ts-ignore
import ClockSVG from './clock.react.svg'
// @ts-ignore
import CloseSVG from './close.react.svg'
// @ts-ignore
import DeliverySVG from './delivery.react.svg'
// @ts-ignore
import DiamondStackSVG from './diamond-stack.react.svg'
// @ts-ignore
import DollarSVG from './dollar.react.svg'
// @ts-ignore
import DropDownSVG from './dropdown.react.svg'
// @ts-ignore
import EmailSVG from './email.react.svg'
// @ts-ignore
import EmptyCircleSVG from './empty-circle.react.svg'
// @ts-ignore
import ErrorSVG from './error.react.svg'
// @ts-ignore
import EyeSVG from './eye.react.svg'
// @ts-ignore
import EyeBackslashSVG from './eye-backslash.react.svg'
// @ts-ignore
import HeartSVG from './heart.react.svg'
// @ts-ignore
import LockSVG from './lock.react.svg'
// @ts-ignore
import MaximizeSVG from './maximize.react.svg'
// @ts-ignore
import MedicationsSVG from './medications.react.svg'
// @ts-ignore
import MenuSVG from './menu.react.svg'
// @ts-ignore
import MessageSVG from './message.react.svg'
// @ts-ignore
import MinimizeSVG from './minimize.react.svg'
// @ts-ignore
import OpportunitiesSVG from './opportunities.react.svg'
// @ts-ignore
import PhoneSVG from './phone.react.svg'
// @ts-ignore
import ProfileSVG from './profile.react.svg'
// @ts-ignore
import ProfileFilledSVG from './profile-filled.react.svg'
// @ts-ignore
import QuestionSVG from './question.react.svg'
// @ts-ignore
import QuestionSlateBlueSVG from './question-slate-blue.react.svg'
// @ts-ignore
import SearchSVG from './search.react.svg'
// @ts-ignore
import SendSVG from './send.react.svg'

/* -----------------------------------------------------------------------------
 * icons
 * -------------------------------------------------------------------------- */

export type IconProps = Omit<SVGProps, 'svg'>

export const ArrowLeftIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return <SVG svg={ArrowLeftSVG} width={width} height={height} {...props} />
}

export const ArrowRightIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return <SVG svg={ArrowRightSVG} width={width} height={height} {...props} />
}

export const AvatarPharmacistFilledIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return (
    <SVG
      svg={AvatarPharmacistFilledSVG}
      width={width}
      height={height}
      {...props}
    />
  )
}

export const BackIcon = ({ width = 24, height = 24, ...props }: IconProps) => {
  return <SVG svg={BackSVG} width={width} height={height} {...props} />
}

export const CalendarIcon = ({
  width = 20,
  height = 20,
  ...props
}: IconProps) => {
  return <SVG svg={CalendarSVG} width={width} height={height} {...props} />
}

export const CautionIcon = ({
  width = 16,
  height = 14,
  ...props
}: IconProps) => {
  return <SVG svg={CautionSVG} width={width} height={height} {...props} />
}

export const CheckMarkVioletIcon = ({
  width = 32,
  height = 23,
  ...props
}: IconProps) => (
  <SVG svg={CheckMarkVioletSVG} width={width} height={height} {...props} />
)

export const CheckMarkWhiteIcon = ({
  width = 32,
  height = 23,
  ...props
}: IconProps) => (
  <SVG svg={CheckMarkWhiteSVG} width={width} height={height} {...props} />
)

export const CheckCircleIcon = ({
  width = 16,
  height = 16,
  ...props
}: IconProps) => (
  <SVG svg={CheckCircleSVG} width={width} height={height} {...props} />
)

export const CheckMarkPulseIcon = ({
  width = 104,
  height = 104,
  ...props
}: IconProps) => {
  return (
    <SVG svg={CheckMarkPulseSVG} width={width} height={height} {...props} />
  )
}

export const CopyIcon = ({ width = 13, height = 15, ...props }: IconProps) => {
  return <SVG svg={CopySVG} width={width} height={height} {...props} />
}

export const ChevronLeftIcon = ({
  width = 7,
  height = 10,
  ...props
}: IconProps) => {
  return <SVG svg={ChevronLeftSVG} width={width} height={height} {...props} />
}

export const ChevronRightIcon = ({
  width = 7,
  height = 10,
  ...props
}: IconProps) => {
  return <SVG svg={ChevronRightSVG} width={width} height={height} {...props} />
}

export const ChevronDownIcon = ({
  width = 10,
  height = 7,
  ...props
}: IconProps) => {
  return <SVG svg={ChevronDownSVG} width={width} height={height} {...props} />
}

export const ClockIcon = ({ width = 16, height = 16, ...props }: IconProps) => {
  return <SVG svg={ClockSVG} width={width} height={height} {...props} />
}

export const CloseIcon = ({ width = 24, height = 24, ...props }: IconProps) => {
  return <SVG svg={CloseSVG} width={width} height={height} {...props} />
}

export const DeliveryIcon = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return <SVG svg={DeliverySVG} width={width} height={height} {...props} />
}

export const DiamondStackIcon = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return <SVG svg={DiamondStackSVG} width={width} height={height} {...props} />
}

export const DollarIcon = ({
  width = 15,
  height = 15,
  ...props
}: IconProps) => {
  return <SVG svg={DollarSVG} width={width} height={height} {...props} />
}

export const DropDownIcon = ({
  fill = 'violet',
  width = 5,
  height = 3,
  ...props
}: IconProps) => {
  return (
    <SVG
      svg={DropDownSVG}
      fill={fill}
      width={width}
      height={height}
      {...props}
    />
  )
}

type ToggleArrowIconProps = IconProps & {
  state: 'up' | 'down'
}

export const ToggleArrowIcon = ({
  fill = 'violet',
  width = 10,
  height = 8,
  state,
  ...props
}: ToggleArrowIconProps) => {
  const icon = state === 'up' ? ArrowUpSVG : DropDownSVG

  return <SVG svg={icon} fill={fill} width={width} height={height} {...props} />
}

export const EmailIcon = ({ width = 18, height = 14, ...props }: IconProps) => {
  return <SVG svg={EmailSVG} width={width} height={height} {...props} />
}

export const EmptyCircleIcon = ({
  width = 16,
  height = 16,
  ...props
}: IconProps) => (
  <SVG svg={EmptyCircleSVG} width={width} height={height} {...props} />
)

export const ErrorIcon = ({ width = 24, height = 24, ...props }: IconProps) => {
  return <SVG svg={ErrorSVG} width={width} height={height} {...props} />
}

export const EyeIcon = ({ width = 20, height = 20, ...props }: IconProps) => {
  return <SVG svg={EyeSVG} width={width} height={height} {...props} />
}

export const EyeBackslashIcon = ({
  width = 20,
  height = 20,
  ...props
}: IconProps) => {
  return <SVG svg={EyeBackslashSVG} width={width} height={height} {...props} />
}

export const HeartIcon = ({ width = 14, height = 13, ...props }: IconProps) => {
  return <SVG svg={HeartSVG} width={width} height={height} {...props} />
}

export const LockIcon = ({ width = 7, height = 9, ...props }: IconProps) => {
  return <SVG svg={LockSVG} width={width} height={height} {...props} />
}

export const MaximizeIcon = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return <SVG svg={MaximizeSVG} width={width} height={height} {...props} />
}

// the tab bar's medications icon, unfocused
export const MedicationsIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return <SVG svg={MedicationsSVG} width={width} height={height} {...props} />
}

export const MenuIcon = ({ width = 24, height = 24, ...props }: IconProps) => {
  return <SVG svg={MenuSVG} width={width} height={height} {...props} />
}

export const MessageIcon = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return <SVG svg={MessageSVG} width={width} height={height} {...props} />
}

export const MinimizeIcon = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return <SVG svg={MinimizeSVG} width={width} height={height} {...props} />
}

// the tab bar's opportunities icon, unfocused
export const OpportunitiesIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return <SVG svg={OpportunitiesSVG} width={width} height={height} {...props} />
}

export const PhoneIcon = ({ width = 16, height = 16, ...props }: IconProps) => {
  const colorFromTheme =
    (props.fill[0] === '#'
      ? props.fill
      : colors[props.fill as keyof typeof colors]) || '#1B1C4E'
  return (
    <SVG
      svg={PhoneSVG}
      width={width}
      height={height}
      // @ts-ignore
      style={{ color: colorFromTheme }}
      {...props}
    />
  )
}

export const ProfileIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return <SVG svg={ProfileSVG} width={width} height={height} {...props} />
}

export const ProfileFilledIcon = ({
  width = 32,
  height = 32,
  ...props
}: IconProps) => {
  return <SVG svg={ProfileFilledSVG} width={width} height={height} {...props} />
}

export const QuestionIcon = ({
  width = 14,
  height = 14,
  ...props
}: IconProps) => {
  return <SVG svg={QuestionSVG} width={width} height={height} {...props} />
}

export const QuestionSlateBlueIcon = ({
  width = 25,
  height = 25,
  ...props
}: IconProps) => {
  return (
    <SVG svg={QuestionSlateBlueSVG} width={width} height={height} {...props} />
  )
}

export const SearchIcon = ({
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return <SVG svg={SearchSVG} width={width} height={height} {...props} />
}

export const SendIcon = ({ width = 24, height = 24, ...props }: IconProps) => {
  return <SVG svg={SendSVG} width={width} height={height} {...props} />
}
